import type { NextPage } from 'next';
import { TermsAE } from '../../../components/termsAndConditions/TermsAED';
import { IMetaHead, IPageMenu } from "../../../interfaces";
import { MetaHead } from '../../../components/shared/metaHead';
import { BreadCrumb } from '../../../components/shared/breadCrumb';
import { SchemaHead } from '@/components/shared/schemaHead';
type props = {
    navSchemaData: IPageMenu[]
}
const TermsAndCondtions: NextPage<props> = ({ navSchemaData }) => {
    const metaData: IMetaHead = {
        title: "Interior Company UAE Payment Terms and Conditions",
        description: "Find information about Interior Company's payment schedules, quote validity, delivery time, order placement, modular delivery & warehousing, taxes and duties & more.",
        // hreflangInCountry:"INR,AED"
    };
    return (
        <>
            <MetaHead metaData={metaData} />
            <BreadCrumb />
            <SchemaHead navSchemaData={navSchemaData} />
            <TermsAE />
        </>

    )
}
export default TermsAndCondtions;